import { faTriangleExclamation } from '@fortawesome/pro-regular-svg-icons';
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
	Callout,
	CalloutIcon,
	Icon,
} from '@uturn/ui-kit';
import { useTranslation } from 'react-i18next';

const CUSTOMER_SERVICE_EMAIL = 'customerservice@uturn-now.com';
const CUSTOMER_SERVICE_PHONE = '+31 (0) 103 106 300';
const CUSTOMER_SERVICE_PHONE_HREF = 'tel:+31103106300';

export const LoginIssuesNotice = () => {
	const { t } = useTranslation();

	return (
		<Callout
			variant="warning"
			className="items-start text-left text-sm"
			dismissible
			dismissAriaLabel={t('pages.auth.sign-in.login-issues.dismiss', 'Dismiss')}
		>
			<CalloutIcon className="pt-0.5">
				<Icon icon={faTriangleExclamation} />
			</CalloutIcon>
			<Accordion type="single" collapsible className="flex-1 pr-6">
				<AccordionItem value="login-issues" className="border-b-0">
					<AccordionTrigger className="py-0 text-left font-semibold text-foreground">
						{t(
							'pages.auth.sign-in.login-issues.title',
							'Login issues for some users',
						)}
					</AccordionTrigger>
					<AccordionContent className="flex flex-col gap-2 pb-0 pt-3 text-foreground">
						<p>
							{t(
								'pages.auth.sign-in.login-issues.description',
								'Some users may be unable to log in to UTURN. This happens because some company firewalls and security services are currently blocking the IP addresses used by our platform. The UTURN platform itself is running normally.',
							)}
						</p>
						<p className="font-semibold">
							{t(
								'pages.auth.sign-in.login-issues.what-you-can-do',
								'What you can do',
							)}
						</p>
						<ul className="list-disc space-y-1 pl-4">
							<li>
								<span className="font-medium">
									{t(
										'pages.auth.sign-in.login-issues.different-network.title',
										'Try a different network.',
									)}
								</span>{' '}
								{t(
									'pages.auth.sign-in.login-issues.different-network.description',
									'Use your mobile hotspot or a home connection, or disconnect from your company VPN.',
								)}
							</li>
							<li>
								<span className="font-medium">
									{t(
										'pages.auth.sign-in.login-issues.contact-it.title',
										'Contact your IT department.',
									)}
								</span>{' '}
								{t(
									'pages.auth.sign-in.login-issues.contact-it.description',
									'Ask them to check whether your firewall or security service is blocking the IP addresses behind portal.uturn-system.com and portal.uturn-now.com. If it is, ask them to add an exception so traffic to and from that address is allowed.',
								)}
							</li>
						</ul>
						<p>
							{t(
								'pages.auth.sign-in.login-issues.urgent',
								'For urgent matters, you can reach us at',
							)}{' '}
							<a
								className="underline"
								href={`mailto:${CUSTOMER_SERVICE_EMAIL}`}
							>
								{CUSTOMER_SERVICE_EMAIL}
							</a>{' '}
							{t('pages.auth.sign-in.login-issues.or', 'or')}{' '}
							<a
								className="whitespace-nowrap underline"
								href={CUSTOMER_SERVICE_PHONE_HREF}
							>
								{CUSTOMER_SERVICE_PHONE}
							</a>
							.
						</p>
						<p>
							{t(
								'pages.auth.sign-in.login-issues.update',
								'We will post an update once the issue is resolved.',
							)}
						</p>
					</AccordionContent>
				</AccordionItem>
			</Accordion>
		</Callout>
	);
};
